'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var set = require('lodash/set');

function setGlobal(path, value) {
    set(window, path, value);
}

window.set = setGlobal;
module.exports = setGlobal;
exports.default = setGlobal;


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/utils/set-global.js
// module id = 417
// module chunks = 0 1